import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Img1 from '../assets/img/carhartt_work.jpg';
import {H3} from '../components/H3';
import {H4} from '../components/H4';
import {H5} from '../components/H5';
import {Icon} from '../components/Icon';
import {Section} from '../components/Section';
import {Select} from '../components/Select';
import {getWorksGroupList, getWorksList} from "../apis/contents";
import {WorksWithUsDto, WorksWithUsGroupDto, WorkWithUsListParams} from "../types/types";

const data = [{id: 1}, {id: 2}, {id: 3}];

const categories = [
    {
        title: '본사 & 물류',
        items: [
            {text: '마케팅 & 컨텐츠 ', path: '/hq/1'},
            {text: '물류 & 로지스틱스', path: '/hq/2'},
            {text: '영업 & 관리', path: '/hq/3'},
            {text: '포토 & 그래픽 디자인', path: '/hq/4'},
        ],
    },
    {
        title: '오프라인 스토어',
        items: [
            {text: 'CARHARTT WIP', path: '/offline-store/5'},
            {text: 'DEUS EX MACHINA', path: '/offline-store/6'},
            {text: 'WORKSOUT', path: '/offline-store/7'},
        ],
    },
];

export const WorkWithUsPage = () => {
    const [tab, setTab] = useState(0);
    const [headList, setHeadList] = useState<WorksWithUsGroupDto[]>([]);
    const [offlineList, setOfflineList] = useState<WorksWithUsGroupDto[]>([]);
    const [searchParams, setSearchParams] = useState<WorkWithUsListParams>({})
    const [list, setList] = useState<WorksWithUsDto[]>([])

    useEffect(() => {
        getWorksGroupList('HEAD_LOGISTICS').then(r => setHeadList(r.data.payload)).catch(e => console.log(e))
        getWorksGroupList('OFFLINE_STORE').then(r => setOfflineList(r.data.payload)).catch(e => console.log(e))
        getWorksList({...searchParams, size: 999}).then(r => setList(r.data.payload.content)).catch(e => console.log(e))
    }, [])

    useEffect(() => {
        searchParams && getWorksList({...searchParams, size: 999}).then(r => setList(r.data.payload.content)).catch(e => console.log(e))
    }, [searchParams])

    useEffect(() => {
        setSearchParams({
            size: 999,
            type: tab === 0 ? 'HEAD_LOGISTICS' : 'OFFLINE_STORE',
        })
    }, [tab])

    return (
        <>
            <div className="-mx-4 -mt-6">
                <div
                    className="w-full md:h-screen-10 bg-center bg-cover bg-no-repeat"
                    style={{backgroundImage: `url('${Img1}')`}}
                >
                </div>
                {/* <img
          src={}
          alt=""
          className="w-full md:h-screen-10 md:object-cover"
        /> */}
            </div>

            <div className="-mx-4">
                <div className="hidden md:block h-screen">
                    <Section className="hidden md:block border-gray-300 sticky_rec w-1/4 float-left">
                        <button
                            className={`${searchParams?.type === undefined ? 'text-black text-gray-600' : 'text-gray-700'} pl-5 border-gray-300 border-b w-full text-left font-normal text-12 py-5`}
                            onClick={() => setSearchParams({})}
                        >
                            전체 <Icon.ArrowRight2 className="inline float-right mr-3 wh-5" />
                        </button>

                        {/*<H4 className={'border-b border-gray-300 w-full pl-5 font-semibold text-12 py-5'}>본사 & 물류</H4>*/}
                        <div className="text-13 text-gray-500 flex flex-col items-start">
                            {headList.map((item, index) => (
                                <button key={index}
                                        className={`${searchParams?.group === item.id ? 'font-normal text-gray-500' : 'font-normal text-gray-700'} border-b border-gray-300 w-full text-left py-5 pl-5`}
                                        onClick={() => setSearchParams({...searchParams, group: item.id, type: 'HEAD_LOGISTICS'})}
                                >
                                    {item.group}
                                    <Icon.ArrowRight2 className="inline float-right mr-3 wh-5" />
                                </button>
                            ))}
                        </div>

                        {/*<H4 className={'border-b-2 border-gray-800 w-max font-semibold'}>오프라인 스토어</H4>*/}
                        <div className="text-13 text-gray-500 flex flex-col items-start">
                            {offlineList.map((item, index) => {
                                if (item.group.indexOf('칼하트') !== -1) {
                                    return (
                                        <button key={index}
                                                className={`${searchParams?.group === item.id ? 'font-normal text-gray-500' : 'font-normal text-gray-700'} border-b border-gray-300 w-full text-left py-5 pl-5`}
                                                onClick={() => setSearchParams({...searchParams, group: item.id, type: 'OFFLINE_STORE'})}
                                        >
                                            {item.group}
                                            <Icon.ArrowRight2 className="inline float-right mr-3 wh-5" />
                                        </button>
                                    )
                                }
                            })}
                        </div>
                    </Section>

                    <Section className="border-l h-screen border-gray-300 w-3/4 float-right overflow-scroll">
                        <H3 className="flex items-center max-w-2xl ml-40 mt-12 text-12 font-normal color333537E6">모집 현황</H3>

                        <div className="space-y-5">
                            {list.length === 0 && <div className="text-gray-900 group flex items-center max-w-2xl ml-40 mt-5 text-12">현재 진행 중인 채용이 없습니다.</div>}
                            {list.sort((a, b) => b.id - a.id)
                                .filter((item) => item.type === 'HEAD_LOGISTICS' || (item.type === 'OFFLINE_STORE' && item.group.group.indexOf('칼하트') !== -1))
                                .map((item, index) => (
                                <Link key={index}
                                      to={`/work-with-us/${item.id}`}
                                      className="group flex items-center max-w-2xl ml-40 mt-5"
                                >
                                    <div className="space-y-2 underline mt-2">
                                        <H4 className="font-normal text-12 inline color333537E6">{item.title}</H4>
                                        <H5 className="font-normal text-gray-700 text-12 inline color333537E6">
                                            {item.workplace.workplace} | {item.role.role}
                                        </H5>

                                        {/*<p className="text-12 text-gray-500">*/}
                                        {/*    {item.content.replace(/(<([^>]+)>)/ig,"")}*/}
                                        {/*</p>*/}
                                    </div>
                                    <button
                                        className="wh-4 mt-2">
                                        <Icon.ArrowRight2 className="wh-4"/>
                                    </button>
                                </Link>
                            ))}
                        </div>
                    </Section>
                </div>

                <div className="flex md:hidden flex-col px-4 space-y-3">
                    <Section className="flex mt-6 space-x-3">
                        {categories.map((category, index) => (
                            <button onClick={() => setTab(index)}>
                                <H4
                                    className={`font-normal border-black p-1 ${
                                        index === tab ? 'text-black border-b-2' : 'text-gray-400'
                                    }`}
                                >
                                    {category.title}
                                </H4>
                            </button>
                        ))}
                    </Section>

                    <Select
                        className="border-black border-1"
                        label=""
                        onChange={(e) => setSearchParams({...searchParams, group: e.target.value !== "" ? parseInt(e.target.value) : undefined, type: tab === 0 ? 'HEAD_LOGISTICS' : 'OFFLINE_STORE'})}
                    >
                        <option value="">전체</option>
                        {(tab === 0 ? headList : offlineList).map((item) => {
                            if (tab === 1 && item.group.indexOf('칼하트') !== -1) {
                                return (
                                    <option key={item.id} value={item.id}>
                                        {item.group}
                                    </option>
                                )
                            } else if (tab === 0) {
                                return (
                                    <option key={item.id} value={item.id}>
                                        {item.group}
                                    </option>
                                )
                            }
                        })}
                    </Select>

                    <Section className="pt-6">
                        <H3 className="font-normal border-b pb-5 mb-5">채용 안내</H3>

                        <div className="space-y-5">
                            {list.length === 0 && <div className="text-gray-900">현재 진행 중인 채용이 없습니다.</div>}
                            {list.sort((a, b) => b.id - a.id)
                                .filter((item) => item.type === 'HEAD_LOGISTICS' || (item.type === 'OFFLINE_STORE' && item.group.group.indexOf('칼하트') !== -1))
                                .map((item) => (
                                <Link
                                    to={`/work-with-us/${item.id}`}
                                    className="group flex items-center border-b pb-5 "
                                >
                                    <div className="max-w-3xl space-y-2">
                                        <H5 className="font-normal">{item.title}</H5>
                                        <H5 className="text-gray-600">
                                            {item.workplace.workplace} | {item.role.role}
                                        </H5>

                                        <p className="text-14 text-gray-500 truncate-2-lines">
                                            {item.content.replace(/(<([^>]+)>)/ig,"")}
                                        </p>
                                    </div>
                                    <div className="flex-1"/>
                                </Link>
                            ))}
                        </div>
                    </Section>
                </div>
                {/* <pre>{JSON.stringify(me, undefined, 2)}</pre> */}
            </div>
        </>
    );
};
